import {
    Alert,
    AlertTitle,
    Grid,
    Snackbar,
  } from "@mui/material";
import { PreventiviNewContext } from "../context";
import React, { useContext, useState } from 'react';
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { RiepilogoPreventivo, PreventivoSingolo} from "../components/PreventiviFormComponent/"
import { v4 as uuidv4 } from "uuid";


const DettaglioPreventivo = () => {
    const [locationMap, setLocationMap] = useState(false);

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
          return;
        }
        setLocationMap(false);
      };

    const{
        state:{
            form,
            result
        }
    } = useContext(PreventiviNewContext);


    function fillMittente() {
     
      return(
        `${form?.MittLocalita}<br>${form?.MittNazione}`        
      );
    }

    function fillDestinatario(){
        return(
            `${form?.DestLocalita}<br>${form?.DestNazione}`
        );
    }


  return (
    <>
    <Grid>
<   Grid container spacing={0} key={uuidv4()}>
      <Snackbar
        open={locationMap}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
          Coordinate non presenti
        </Alert>
      </Snackbar>
      {form?.MittLocalita !== "" ? (
        <Grid item xs={12} md={6} lg={6} key={uuidv4()}>
          <Alert severity="info" icon={<></>} sx={{ background: (theme) => theme.palette.error.light + "25" }}>
            <AlertTitle><strong>Mittente</strong></AlertTitle>
            {
              <ReactMarkdown
                children={form ? fillMittente() : ""}
                rehypePlugins={[rehypeRaw]}
              ></ReactMarkdown>
            }{" "}
          </Alert>
        </Grid>
      ) : (
        <></>
      )}
    {/* <ArrowForwardIosIcon/> */}
    {form?.DestLocalita !== "" ? (
        <Grid item xs={12} md={6} lg={6} key={uuidv4()} >
          <Alert severity="success" icon={<></>}>
          <AlertTitle><strong>Destinatario</strong></AlertTitle>
            {
              <ReactMarkdown
                children={form ? fillDestinatario() : ""}
                rehypePlugins={[rehypeRaw]}
              ></ReactMarkdown>
            }{" "}
          </Alert>
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
    <RiepilogoPreventivo  />

    </Grid>

    {/* <Container>     */}
      {
        result.map((element) => {
          if (element.Importo !== ""){
            return(
              <PreventivoSingolo DatiPreventivo={element} />
            )     
          }     
          return(<></>);  
        })
      }
    {/* </Container>       */}

      </>
  )
}

export default DettaglioPreventivo